// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"ea1bb4b7","231":"570e4774","419":"39103966","453":"e2336c3c","834":"15d8c204"}[chunkId] + ".chunk.js";
};